import { z } from 'zod';

export const themesSearchParamsSchema = z.object({
  texto: z.string().optional(),
  categorias: z.array(z.coerce.number()).optional(),
  tipo: z.enum(['RED1000', 'ESCOLA']).optional(),
  tag: z.string().optional(),
  uso: z.enum(['UTILIZADO', 'NAO_UTILIZADO']).optional(),
  ano: z.coerce.number().optional(),
  generos: z.array(z.coerce.number()).optional(),
  escola: z.coerce.number().optional(),
  pagina: z.coerce.number().optional(),
  ordem: z.enum(['recentes', 'utilizados', 'titulo']).optional(),
});

export type ThemesSearchParams = z.infer<typeof themesSearchParamsSchema>;
